// removed by extract-text-webpack-plugin
module.exports = {"avatar":"evfPSpDvFVhK68svMaWJn","header":"_3NMdScg7Iv8yDgxEp-X66O","name":"_3hgahzR7NNrX6GOazrpabp","time":"_1oYkLUTyVhuaYn5LPmdQSy","adminAction":"_3FStia-ydpR_LUgZaTD4i3","iconAction":"E8KgO4T78CBXdRwJOkfdk"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Containers/Header/style.css
// module id = 632
// module chunks = 38